import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const SVG_NS = 'http://www.w3.org/2000/svg'

export default function logoLetterScroll() {
  const container = document.getElementById('logo-letter-scroll')
  if (!container) return

  const svg = container.querySelector('svg')
  const defs = svg.querySelector('defs')
  const letters = svg.querySelectorAll('.letter')

  if (!letters.length) return

  // Extra vertical spacing between .letter and .letter-dup (≈ 3rem in SVG units)
  const gap = 440

  const groupEls = []
  const animTargets = []

  letters.forEach((path, i) => {
    const bbox = path.getBBox()
    const clipId = `clip-letter-${i}`

    // 1. Create clipPath at full bbox size
    const clipPath = document.createElementNS(SVG_NS, 'clipPath')
    clipPath.setAttribute('id', clipId)
    const rect = document.createElementNS(SVG_NS, 'rect')
    rect.setAttribute('x', bbox.x)
    rect.setAttribute('y', bbox.y)
    rect.setAttribute('width', bbox.width)
    rect.setAttribute('height', bbox.height)
    clipPath.appendChild(rect)
    defs.appendChild(clipPath)

    // 2. Clone the path and shift it above with extra gap
    //    Position = -(bbox.height + gap) so there's spacing between both
    const clone = path.cloneNode(true)
    clone.removeAttribute('id')
    clone.classList.remove('letter')
    clone.classList.add('letter-dup')
    clone.setAttribute('transform', `translate(0, -${bbox.height + gap})`)

    // 3. Create wrapper groups
    const clipGroup = document.createElementNS(SVG_NS, 'g')
    clipGroup.setAttribute('clip-path', `url(#${clipId})`)

    const letterGroup = document.createElementNS(SVG_NS, 'g')
    letterGroup.classList.add('letter-group')

    // 4. Assemble: clipGroup > letterGroup > [original path, clone]
    path.parentNode.insertBefore(clipGroup, path)
    letterGroup.appendChild(path)
    letterGroup.appendChild(clone)
    clipGroup.appendChild(letterGroup)

    groupEls.push(letterGroup)
    // Animation must travel bbox.height + gap so the dup fully enters the clip
    animTargets.push(bbox.height + gap)
  })

  // 5. Build a timeline with ScrollTrigger scrub
  //    Shuffle order for random stagger effect (same as reference)
  const indices = Array.from({ length: groupEls.length }, (_, i) => i)
  for (let i = indices.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[indices[i], indices[j]] = [indices[j], indices[i]]
  }

  const staggerGap = 0.06

  // Use the closest scrollable ancestor (footer) as trigger
  // so the animation has enough scroll distance to complete
  const footer = container.closest('footer') || container

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: footer,
      start: 'top 50%',
      end: 'bottom bottom',
      scrub: 1,
    },
  })

  indices.forEach((idx, order) => {
    tl.to(
      groupEls[idx],
      {
        y: animTargets[idx],
        ease: 'power1.inOut',
        duration: 1,
      },
      order * staggerGap
    )
  })
}
